import React, { FC } from 'react';
import { PortalDialog } from '@component/Portal';
import { Modal } from '@app/react/uikit/Modal';
import type { PartsProduct } from '@app/react/const/type';
import {
    NO_IMAGE_PRODUCT_PATH,
    ORDER_PARTS_NAME,
    OrderPartsType,
} from '@app/react/const/variables';

interface BreadcrumbsProps {
    links: Array<string>;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({
    links,
}) => (
    <>
        {links.map((link, index, list) => {
            if (link === '') {
                return null;
            }
            return (
                <React.Fragment key={link}>
                    { link }
                    {list[index + 1] !== undefined && '＞'}
                </React.Fragment>
            );
        })}
    </>
);

export interface ZoomDialogProps {
    isShow: boolean;
    setisshow: (v: boolean) => void;
    product: PartsProduct;
    openPartsName: OrderPartsType | null;
}

export const ZoomDialog: FC<ZoomDialogProps> = ({
    isShow,
    setisshow,
    product,
    openPartsName,
}) => {
    const imgSrc = product.productImages[0] ?? NO_IMAGE_PRODUCT_PATH;
    const partsName = ORDER_PARTS_NAME.ja[openPartsName] ?? '...';
    const links = [
        partsName,
        product.categoryName,
        product.subCategoryName,
    ];

    return (
        <PortalDialog className="zoom-dialog">
            <Modal show={isShow} setShow={() => setisshow(true)}>
                <div className="zoom-dialog__div">
                    <img src={imgSrc} alt="商品画像" />
                </div>
                <span className="zoom-dialog__category">
                    <Breadcrumbs links={links} />
                </span>
                <span className="zoom-dialog__name">{product.name}</span>
                <span className="zoom-dialog__label">金額</span>
                <span className="zoom-dialog__price">
                    1本あたり：￥
                    {product.price.toLocaleString()}
                    <span className="zoom-dialog__price__comment">
                        ※こちらをオーダーした際にかかる差額です。
                    </span>
                </span>

                <div className="footer">
                    <button
                        type="button"
                        className="normal-button"
                        onClick={() => setisshow(false)}
                    >
                        × 閉じる
                    </button>
                </div>
            </Modal>
        </PortalDialog>
    );
};
